module.exports = __webpack_public_path__ + "media/images/about/history/history-1-1e2212bd010a4ff2b2e80b91cf5317ae.png";